import StripeEmbeddedComponentsController from "../../../../../frontend/controllers/payment/stripe_connect/embedded_components/stripe_embedded_components_controller"
import { useCompleteCollectionOptions } from "../../../../helpers/stripe_connect/embedded_components/collection_options_helper";

// Connects to data-controller="stripe-embedded-account-management-component"
export default class extends StripeEmbeddedComponentsController {

  connect() {
    this.componentConfigurations.push(useCompleteCollectionOptions);

    super.connect()
  }

  get componentType() {
    return "account-management"
  }
}